<template>
    <va-create-layout>
        <FBALiquidationEvent-form
            :title="title"
            :item="item"
        ></FBALiquidationEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
